import script from "./PublishTask.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishTask.vue?vue&type=script&setup=true&lang=js"

import "./PublishTask.vue?vue&type=style&index=0&id=62136369&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62136369"]])

export default __exports__